import React from 'react';
import PropTypes, { oneOfType } from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import Button from '../Button/CustomButton';
import GridContainer from '../Grid/GridContainer';

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);
const useStyles = makeStyles(() => ({
    marginBottom20: {
        marginBottom: 20,
    },
    textCenter: {
        textAlign: 'center',
    },
    titleDialog: {
        display: 'flex',
        minWidth: '350px',
        color: (props) => props?.contents_text_color,
    },
    root: {
        color: (props) => props?.contents_text_color,
    },
}));
export default function ConfirmDialog(props) {
    const {
        title,
        handleClose,
        open,
        contents,
        titleButton,
        colorButton,
        customColor,
    } = props;
    const classes = useStyles(customColor);

    return (
        <div>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-labelledby="simple-dialog-title"
                className={classes.textCenter}
            >
                <DialogTitle
                    id="simple-dialog-title"
                    classes={{ root: classes.titleDialog }}
                >
                    {title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText classes={{ root: classes.root }}>
                        {contents}
                    </DialogContentText>
                </DialogContent>
                <GridContainer
                    direction="row"
                    justify="center"
                    alignItems="center"
                    className={classes.marginBottom20}
                >
                    <Button color={colorButton} round gradient size="md" onClick={handleClose} buttonTextColor={customColor?.button_text_color}>
                        {titleButton}
                    </Button>
                </GridContainer>
            </Dialog>
        </div>
    );
}

ConfirmDialog.defaultProps = {
    title: 'Alert Dialog Title',
    handleClose: {},
    open: false,
    contents: 'Alert Dialog Contents',
    titleButton: 'OK',
    colorButton: 'success',
    customColor: {},
};

ConfirmDialog.propTypes = {
    title: PropTypes.string,
    handleClose: PropTypes.func,
    open: PropTypes.bool,
    contents: oneOfType([() => null, PropTypes.string, PropTypes.node]),
    titleButton: PropTypes.string,
    colorButton: PropTypes.string,
    customColor: PropTypes.oneOfType([() => null, PropTypes.object]),
};
